import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

interface ChipFilterProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	on?: boolean;
	count?: ReactNode;
}

export function ChipFilter({
	on,
	count,
	className,
	children,
	...props
}: ChipFilterProps) {
	return (
		<button className={cn("chip-filter", on && "on", className)} {...props}>
			{children}
			{count !== undefined && <span className="ct tn">{count}</span>}
		</button>
	);
}
